(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hsx-home-numbers"] && !Shopify.designMode) return;
  try {
    
(() => {
  'use strict';
  if (customElements.get('hsx-number-strip')) return;
  customElements.define('hsx-number-strip', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      this.frames = new Map();
      this.finished = new WeakSet();
      this.values = [...this.querySelectorAll('[data-hsxn-value]')];
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.reduced.addEventListener('change', () => { if (this.still()) this.finish(); }, {signal: this.abort.signal});
      this.preference = new MutationObserver(() => { if (this.still()) this.finish(); });
      this.preference.observe(document.documentElement, {attributes: true, attributeFilter: ['data-hsx-motion']});
      document.addEventListener('visibilitychange', () => { if (document.hidden) this.finish(); }, {signal: this.abort.signal});
      if (this.still() || !('IntersectionObserver' in window)) return;
      this.observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          this.observer.unobserve(entry.target);
          this.play(entry.target);
        });
      }, {threshold: .5});
      this.values.filter(el => el.dataset.animate === 'true').forEach(el => this.observer.observe(el));
    }
    still() {
      return this.dataset.enabled !== 'true' || document.documentElement.dataset.hsxMotion === 'false' || this.reduced.matches || !!navigator.connection?.saveData;
    }
    play(el) {
      if (this.finished.has(el) || this.still()) return;
      this.finished.add(el);
      const source = el.dataset.value.trim();
      if (!/^\d+(\.\d+)?$/.test(source)) return;
      const goal = Number(source);
      if (!Number.isFinite(goal) || goal < 0 || goal > 1000000000) return;
      const places = Math.min(2, (source.split('.')[1] || '').length);
      const format = new Intl.NumberFormat(document.documentElement.lang || 'en', {minimumFractionDigits: places, maximumFractionDigits: places});
      const start = performance.now();
      const tick = now => {
        if (!el.isConnected || this.still()) { el.textContent = source; this.frames.delete(el); return; }
        const progress = Math.min(1, (now - start) / 1000);
        el.textContent = format.format(goal * (1 - Math.pow(1 - progress, 3)));
        if (progress < 1) this.frames.set(el, requestAnimationFrame(tick));
        else { el.textContent = source; this.frames.delete(el); }
      };
      this.frames.set(el, requestAnimationFrame(tick));
    }
    finish() {
      this.frames?.forEach(frame => cancelAnimationFrame(frame));
      this.frames?.clear();
      this.values?.forEach(el => { el.textContent = el.dataset.value; });
      this.observer?.disconnect();
    }
    disconnectedCallback() {
      this.finish();
      this.abort?.abort();
      this.preference?.disconnect();
      this.abort = null;
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hsx-v2-home-press"] && !Shopify.designMode) return;
  try {
    
/* Transform-only, measured loop; no timers, network calls, cart or analytics hooks. */
(() => {
  'use strict';
  if (customElements.get('hsx-press-ribbon')) return;
  customElements.define('hsx-press-ribbon', class extends HTMLElement {
    connectedCallback() {
      this.frame = requestAnimationFrame(() => this.setup());
    }
    setup() {
      this.frame = 0;
      if (!this.isConnected || this.abort) return;
      this.track = this.querySelector('[data-press-track]');
      this.group = this.querySelector('[data-press-original]');
      this.viewport = this.querySelector('[data-press-viewport]');
      if (!this.track || !this.group || !this.viewport) return;
      this.abort = new AbortController();
      const options = {signal: this.abort.signal};
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.editorSelections = new Set();
      this.hovered = false;
      this.focused = false;
      this.visible = !('IntersectionObserver' in window);
      this.viewport.addEventListener('pointerenter', event => {
        if (event.pointerType === 'mouse') { this.hovered = true; this.sync(); }
      }, options);
      this.viewport.addEventListener('pointerleave', () => { this.hovered = false; this.sync(); }, options);
      this.viewport.addEventListener('focusin', () => { this.focused = true; this.sync(); }, options);
      this.viewport.addEventListener('focusout', () => { this.focused = false; this.sync(); }, options);
      document.addEventListener('visibilitychange', () => this.sync(), options);
      this.reduced.addEventListener('change', () => this.refresh(), options);
      window.addEventListener('resize', () => this.schedule(), {...options, passive: true});
      ['section', 'block'].forEach(type => {
        ['select', 'deselect'].forEach(action => {
          document.addEventListener(`shopify:${type}:${action}`, event => {
            if (!(event.target.contains(this) || this.contains(event.target))) return;
            const key = type + (event.detail?.blockId || event.detail?.sectionId || '');
            if (action === 'select') this.editorSelections.add(key);
            else this.editorSelections.delete(key);
            this.refresh();
          }, options);
        });
      });
      if ('ResizeObserver' in window) {
        this.resize = new ResizeObserver(() => this.schedule());
        this.resize.observe(this.group);
        this.resize.observe(this.viewport);
      }
      if ('IntersectionObserver' in window) {
        this.intersection = new IntersectionObserver(entries => {
          this.visible = entries.some(entry => entry.isIntersecting);
          this.sync();
        });
        this.intersection.observe(this);
      }
      this.refresh();
      document.fonts?.ready.then(() => { if (this.isConnected) this.schedule(); });
    }
    schedule() {
      if (!this.frame) this.frame = requestAnimationFrame(() => { this.frame = 0; this.refresh(); });
    }
    refresh() {
      if (!this.isConnected || !this.track) return;
      const allowed = this.dataset.enabled === 'true' && !this.reduced.matches &&
        this.editorSelections.size === 0 && this.group.children.length > 1 && typeof this.track.animate === 'function';
      if (!allowed) {
        this.animation?.cancel(); this.animation = null; this.distance = 0;
        this.dataset.mode = 'static';
        this.track.querySelectorAll('[data-press-copy]').forEach(node => node.remove());
        this.dataset.running = 'false';
        return;
      }
      this.dataset.mode = 'loop';
      const distance = this.group.getBoundingClientRect().width;
      if (distance <= 0) return;
      const copies = Math.max(1, Math.ceil(this.viewport.clientWidth / distance));
      const existing = [...this.track.querySelectorAll('[data-press-copy]')];
      while (existing.length > copies) existing.pop().remove();
      while (existing.length < copies) {
        const clone = this.group.cloneNode(true);
        clone.removeAttribute('data-press-original');
        clone.setAttribute('data-press-copy', '');
        clone.setAttribute('aria-hidden', 'true');
        clone.querySelectorAll('*').forEach(node => {
          [...node.attributes].forEach(attribute => {
            if (attribute.name === 'id' || attribute.name.startsWith('data-shopify-editor')) node.removeAttribute(attribute.name);
          });
        });
        this.track.append(clone); existing.push(clone);
      }
      if (!this.animation || Math.abs(distance - this.distance) > .25) {
        const progress = this.animation?.effect.getComputedTiming().progress || 0;
        this.animation?.cancel();
        const speed = Math.min(48, Math.max(16, Number(this.dataset.speed) || 28));
        const duration = distance / speed * 1000;
        this.animation = this.track.animate([
          {transform: 'translate3d(0,0,0)'},
          {transform: `translate3d(${-distance}px,0,0)`}
        ], {duration, iterations: Infinity, easing: 'linear'});
        this.animation.currentTime = progress * duration;
        this.distance = distance;
      }
      this.sync();
    }
    sync() {
      if (!this.animation) return;
      const running = this.visible && !document.hidden && !this.hovered && !this.focused;
      if (running && this.animation.playState !== 'running') this.animation.play();
      if (!running && this.animation.playState !== 'paused') this.animation.pause();
      this.dataset.running = String(running);
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame); this.frame = 0;
      this.abort?.abort(); this.abort = null;
      this.resize?.disconnect(); this.intersection?.disconnect();
      this.animation?.cancel(); this.animation = null; this.distance = 0;
      this.querySelectorAll('[data-press-copy]').forEach(node => node.remove());
      delete this.dataset.mode; delete this.dataset.running;
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hx-home-press"] && !Shopify.designMode) return;
  try {
    
(() => {
  'use strict';
  if (window.HSXGlassPress) { window.HSXGlassPress.refresh(); return; }
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const states = new Map();
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => { const s=states.get(entry.target); if(s){s.visible=entry.isIntersecting;sync(s);} });
  }, {rootMargin:'40px'}) : null;
  function measure(s) {
    if(!s.node.classList.contains('is-ticker')) return;
    const distance=s.group.getBoundingClientRect().width;
    const speed=Math.max(10,Math.min(40,Number(s.node.dataset.speed)||22));
    if(distance>0){s.node.style.setProperty('--press-distance',`${distance}px`);s.node.style.setProperty('--press-duration',`${distance/speed}s`);}
  }
  function sync(s) {
    const ticker=!reduced.matches && s.node.dataset.enableMotion !== 'false' && !s.editor && s.group.children.length>1;
    const changed=s.node.classList.contains('is-ticker')!==ticker;
    s.node.classList.toggle('is-ticker',ticker);
    s.node.dataset.pressRunning=String(ticker && s.visible && !document.hidden);
    if(changed)measure(s);
  }
  function init(scope=document) {
    const nodes=[...(scope.matches?.('[data-hx-press-glass]')?[scope]:[]),...scope.querySelectorAll('[data-hx-press-glass]')];
    nodes.forEach(node=>{
      if(states.has(node))return;
      const track=node.querySelector('[data-press-track]');
      const group=node.querySelector('[data-press-original]');
      const viewport=node.querySelector('[data-press-window]');
      if(!track||!group||!viewport)return;
      const s={node,track,group,visible:!observer,editor:false,resize:null,frame:0};
      states.set(node,s);
      for(let i=0;i<2;i++){
        const copy=group.cloneNode(true);
        copy.removeAttribute('data-press-original');copy.setAttribute('data-press-copy','');copy.setAttribute('aria-hidden','true');
        copy.querySelectorAll('[data-shopify-editor-block]').forEach(n=>n.removeAttribute('data-shopify-editor-block'));
        track.append(copy);
      }
      if('ResizeObserver' in window){s.resize=new ResizeObserver(()=>{cancelAnimationFrame(s.frame);s.frame=requestAnimationFrame(()=>measure(s));});s.resize.observe(viewport);}
      sync(s);measure(s);observer?.observe(node);
      document.fonts?.ready.then(()=>{if(node.isConnected)measure(s);});
    });
  }
  const syncAll=()=>states.forEach(sync);
  reduced.addEventListener('change',syncAll);
  document.addEventListener('visibilitychange',syncAll);
  document.addEventListener('shopify:section:load',e=>init(e.target));
  document.addEventListener('shopify:section:unload',e=>{
    for(const [node,s] of states)if(e.target===node||e.target.contains(node)){
      s.resize?.disconnect();cancelAnimationFrame(s.frame);observer?.unobserve(node);
      node.querySelectorAll('[data-press-copy]').forEach(n=>n.remove());states.delete(node);
    }
  });
  document.addEventListener('shopify:section:select',e=>states.forEach(s=>{if(e.target===s.node||e.target.contains(s.node)){s.editor=true;sync(s);}}));
  document.addEventListener('shopify:section:deselect',e=>states.forEach(s=>{if(e.target===s.node||e.target.contains(s.node)){s.editor=false;sync(s);}}));
  window.HSXGlassPress={version:'2026-10-08-internal',refresh:()=>init(),status:()=>[...states.values()].map(s=>({ticker:s.node.classList.contains('is-ticker'),running:s.node.dataset.pressRunning==='true',copies:s.track.querySelectorAll('[data-press-copy]').length}))};
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init());else init();
})();

  } catch(e) { console.error(e); }
})();
})();
